<template>
  <div style="height: 100%;">
    <div>
      <div class="flex-x-center flex-between" style="margin-bottom: 20px;">
        <h3>页面及模块</h3>
      </div>
      <!-- <a-auto-complete
        class="certain-category-search"
        dropdown-class-name="certain-category-search-dropdown"
        :dropdown-match-select-width="500"
        style="width: 100%;"
      >
        <a-input-search placeholder="input here" size="middle"></a-input-search>
      </a-auto-complete> -->
    </div>
    <a-menu
      @click="menuChange"
      v-model:openKeys="openKeys"
      v-model:selectedKeys="selectedKeys"
      mode="inline"
      style="overflow-y: scroll;height: 847px;overflow-x: hidden;"
    >
      <a-sub-menu
        v-for="item in categoryList"
        cccccccccccccccccccccc
        :key="item.id"
      >
        <template #title>
          {{ item.name }}
        </template>
        <a-menu-item :key="sub.id" v-for="sub in item.children">
          {{ sub.name }}
        </a-menu-item>
      </a-sub-menu>
    </a-menu>
  </div>
</template>
<script setup>
import { defineEmits, ref, onBeforeMount, defineExpose } from 'vue'
import useAPI from 'UseApi'
const { category_list_post_ } = useAPI(null, [8992, 8997])

const openKeys = ref([])
const selectedKeys = ref([])
const categoryList = ref([])

const getCategory = async () => {
  const res = await category_list_post_()
  categoryList.value = res
  selectedKeys.value = [res[0]?.children[0]?.id]
  openKeys.value = [res[0]?.id]
  emit('initCategoryId', [res[0]?.children[0]?.id])
}

onBeforeMount(() => {
  getCategory()
})

const menuChange = ({ key }) => {
  emit('menuChange', key)
}

const emit = defineEmits(['categoty', 'menuChange', 'initCategoryId'])
defineExpose({ getCategory, selectedKeys, openKeys })
</script>

<style>
.pointer {
  cursor: pointer;
  user-select: none;
}
.flex-x-center {
  display: flex;
  align-items: center;
}
.flex-between {
  justify-content: space-between;
}
.ant-menu-submenu-title {
  padding-left: 40px !important;
  padding-right: 0 !important;
}
.ant-menu-submenu-arrow {
  left: 16px;
  right: auto;
}

.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border: none;
}
.ant-menu-item {
  padding-right: 0 !important;
}
.ant-menu-item::after {
  border: none !important;
}

.ant-menu-sub.ant-menu-inline {
  background: transparent;
}
</style>
